import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'

export const getUserAccountLink = (accountLinks: AccountLinkModel[], userId?: string | number): AccountLinkModel | undefined => {
  return accountLinks.find(accountLink => accountLink.accountId.toString() === userId?.toString())
}
